import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const submitProcedureShopperSuccess = () => {
  return {
    type: actionTypes.SUBMIT_PROCEDURE_SHOPPER_SUCCESS,
  };
};
export const submitProcedureShopperFailed = (error) => {
  return {
    type: actionTypes.SUBMIT_PROCEDURE_SHOPPER_FAILED,
    payload: error,
  };
};
export const submitProcedureShopperStarted = () => {
  return {
    type: actionTypes.SUBMIT_PROCEDURE_SHOPPER_STARTED,
  };
};
export const submitProcedureShopper = (formdata) => {
  return (dispatch) => {
    dispatch(submitProcedureShopperStarted());
    axios
      .post(serverconfigs.submitProcedureShopperUrl, formdata)
      .then((response) => {
        console.log(response);
        dispatch(submitProcedureShopperSuccess());
      })
      .catch((error) => {
        let errorMessage = "";
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(submitProcedureShopperFailed(errorMessage));
      });
  };
};
